
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createProject } from "../api/createProject"
import { showToast } from "../../../utils/toast";
import { useAppSelector } from "store";
import { selectAuthUser } from "store/slices/auth/auth.selector";
import toast from "react-hot-toast";


export const useCreateProjectMutation = () =>{
  const queryClient = useQueryClient();
  const user = useAppSelector(selectAuthUser);
  
return  useMutation({
    mutationFn: createProject,

   onError: (error: any) => {
  if (error.isBusinessError) {
   toast.error(error.message);
    return;
  }

  if (error.isNetworkError) {
    toast.error("Network error. Please try again.");
    return;
  }

  toast.error("Something went wrong");
},

    onSuccess: () => {
      // Refetch the projects list immediately after successful creation
      queryClient.invalidateQueries({
         queryKey: ["projects", user?.appUserUuid], 
      });
         toast.success('Project created successfully');
   
    },
  })
}
